/**
 * @author Marco Visin
 * @date 2025-05-30
 */

import { INodeProperties } from 'n8n-workflow';

export const statusOperations: INodeProperties[] = [
	{
		displayName: 'Operation',
		name: 'operation',
		type: 'options',
		noDataExpression: true,
		displayOptions: {
			show: {
				resource: ['status'],
			},
		},
		options: [
			{
				name: 'Get All',
				value: 'getAll',
				description: 'Get all statuses',
				action: 'Get all statuses',
			},
			{
				name: 'Create',
				value: 'create',
				description: 'Create a new status',
				action: 'Create a status',
			},
		],
		default: 'getAll',
	},
];

export const statusFields: INodeProperties[] = [
	// Get All fields
	{
		displayName: 'Type',
		name: 'type',
		type: 'options',
		options: [
			{
				name: 'Contact',
				value: 'contact',
			},
			{
				name: 'Job',
				value: 'job',
			},
		],
		displayOptions: {
			show: {
				resource: ['status'],
				operation: ['getAll', 'create'],
			},
		},
		default: 'contact',
		description: 'The type of status to retrieve',
	},

	// Create fields
	{
		displayName: 'Name',
		name: 'name',
		type: 'string',
		required: true,
		displayOptions: {
			show: {
				resource: ['status'],
				operation: ['create'],
			},
		},
		default: '',
		description: 'The name of the status',
	},
];
